import moment from "moment";
import _ from "lodash";

export const getLocalDT = (time) => {
  var localDT = " ";
  if (!_.isEmpty(time)) {
    let gmtDateTime = moment.utc(time, "YYYY-MM-DD hh:mmA");
    localDT = gmtDateTime.local().format("YYYY-MM-DD h:mm A");
  }
  return localDT;
};

export const formatSecondsForLongDisplay = (seconds) => {
  return new Intl.DateTimeFormat("en", {
    dateStyle: "long",
    timeStyle: "long",
  }).format(new Date(seconds * 1000));
};

export const formatSecondsForDate = (seconds) => {
  let gmtDateTime = moment.utc(new Date(seconds * 1000), "MM/DD/YYYY hh:mmA");
  return gmtDateTime.local().format("MMM DD, YYYY");
};


export const formatSecondsForDateOnly = (seconds) => {
  let gmtDateTime = moment.utc(new Date(seconds * 1000), "MM/DD/YYYY hh:mmA");
  return gmtDateTime.local().format("MM/DD/YYYY");
};

export const calculateDateDifInDays = (dateA, dateB) => {
  const a = moment(dateA);
  const b = moment(dateB);

  return a.diff(b, "days") + 1;
}


// WEBPACK FOOTER //
// ./src/layout/utils/timeUtils.js